export default __webpack_public_path__ + "static/media/cain14.2dd7626a.jpg";